<template>
	<div class="background-experience">
		<div class="app-wrapper">
			<h2 class="title">ARIS Ecuador</h2>
			<div class="container-oval">
				<div class="wrapper-oval">
					<div class="oval">	
						<p class="paragraph">
							<span class="text-number">+ </span><IOdometer class="text-big" :value="number"/><br>
							<span class="text-bottom text-year">años de experiencia</span> 
						</p>
					</div>
				</div>
				<div class="wrapper-oval">
					<div class="oval">	
						<p class="paragraph">
							<span class="text-number">N°</span><IOdometer class="text-big text-section-two" :value="numberOne"/><br>
							<span class="text-bottom text-bottom-big text-sales">en ventas de Silicato de sodio y ácido sulfúrico</span> 
						</p>
					</div>
				</div>
				<div class="wrapper-oval">
					<div class="oval">	
						<p class="paragraph">
							<IOdometer class="text-big text-section" :value="numberTwo"/><span class="text-medium">da</span><br>
							<span class="text-bottom text-bottom-big text-plant">Planta más grande de Sulfato de Aluminio</span> 
						</p>
					</div>
				</div>
				<div class="wrapper-oval">
					<div class="oval">	
						<p class="paragraph">
							<span class="text-number">+ </span><IOdometer class="text-big" :value="numberThree"/><br>
							<span class="text-bottom-work text-year">Colaboradores</span> 
						</p>
					</div>
				</div>
				<div class="wrapper-oval">
					<div class="oval">	
						<p class="paragraph">
							<IOdometer class="text-medium-two text-section" :value="numberFour"/><span class="text-medium text-sup">m<sup class="sup-index">2</sup></span><br>
							<span class="text-bottom-two text-plant">planta en Milagro, Ecuador</span> 
						</p>
					</div>
				</div>
			</div>
		</div>	
	</div>
</template>

<script>
	import IOdometer from 'vue-odometer';
	import 'odometer/themes/odometer-theme-default.css';
	
	function data() {
		return {
			number: 0,
			numberOne: 0,
			numberTwo: 0,
			numberThree: 0,
			numberFour: 0,
		};
	}

	function counter() {
		if (window.scrollY > 2638 && window.scrollY < 3747) {
			if (this.number === 0 && this.numberOne === 0) {
				setTimeout(() => {
					this.number = 36;
					this.numberOne = 1;
					this.numberTwo = 2;
					this.numberThree = 100;
					this.numberFour = 100000;
				}, 1000);
			}
		}
	}

	function destroyed() {
		window.removeEventListener('scroll', this.counter);
	}

	function mounted() {
		window.addEventListener('scroll', this.counter);
	}

	export default {
		name: 'experience',
		destroyed,
		mounted,
		components: {
			IOdometer,
		},
		data,
		methods: {
			counter,
		},
	};
</script>


<style lang="scss" scoped>
	.background-experience {
		background-image: url('https://ws-aris.s3.amazonaws.com/static/1900px-(1).jpg');
		background-position: center;
		background-size: cover;
		padding-top: 25px;
	}

	.oval {
		background-image: url('https://ws-aris.s3.amazonaws.com/static/experience-oval.png');
		background-size: cover;
		height: 209px;
		margin: auto;
		position: relative;
		width: 209px;
	}

	.title {
		@include font-size(20);
		@include font-maison-bold();
		color: map-get($colors, white);
		margin-bottom: 45px;
		text-align: center;
	}

	.text-big {
    @include font-size(64);
    display: inline-block;
    margin-bottom: -5px;
	}

	.text-medium-two {
		@include font-size(50);
    display: inline-block;
    margin-bottom: -5px;
	}

	.text-medium {
		@include font-size(35);
		margin-top: -7px;
		position: absolute;
    top: 37px;
	}

	.text-number {
		@include font-size(48);
		position: absolute;
    top: 29px;
	}

	.text-big, .text-medium, .text-number, .text-medium-two {
		@include font-maison-bold();
		color: map-get($colors, white);
	}

	.text-bottom {
		bottom: -10px;
		color: map-get($colors, white);
    @include font-size(27);
    line-height: 1.2;
		position: absolute;
	}

	.text-bottom-work {
		bottom: 21px;
		color: map-get($colors, white);
    @include font-size(27);
    line-height: 1.2;
		position: absolute;
	}

	.text-bottom-two {
		bottom: -85px;
		color: map-get($colors, white);
    @include font-size(27);
    line-height: 1.2;
		position: absolute;
	}

	.text-bottom-big {
		bottom: -90px !important;
	}

	.text-section-two {
		margin-left: 22px !important;
	}

	.paragraph {
		left: 0px;
		position: relative;
    top: 27px;
	}

	.container-oval {
		@include flex-around();
	}

	.oval-desktop {
		display: none;
	}

	.iOdometer {
    font-size: 2em;
    margin: 0;
	}

	.text-section {
		margin-left: -35px !important;
	}

	.text-year {
		margin-bottom: -45px;
    margin-left: -12px;
    text-align: center;
    width: 176px;
	}

	.text-sales {
    margin-top: 10px;
    margin-left: -51px;
		text-align: center;
    width: 206px;
    display: block;
	}

	.text-plant {
		margin-left: -50px;
		text-align: center;
    width: 229px;
	}

	.wrapper-oval {
		margin-top: 20px;
		width: 100%;
	}

	.sup-index {
		@include font-size(20);
	}

	.text-sup {
		top: 23px !important;
	}

	@media (min-width: 1029px) {
		.background-experience {
			background-image: url('https://ws-aris.s3.amazonaws.com/static/XqAVqufnjs0C9qC&B3gH07Bh06cHeE.jpg');
			background-size: cover;
		}
		
		.title {
			@include font-size(36);
		}

		.oval-desktop {
			display: block;
		}

		.container-oval {
			margin-top: 100px;
		}

		.background-experience {
      padding: 70px 0px;
      min-height: 70vh;
		}

		.oval {
			height: 246px;
			width: 246px;
		}

		.text-big {
			@include font-size(72);
		}

		.text-medium-two {
			@include font-size(62);
		}

		.text-medium {
			@include font-size(35);
		}

		.wrapper-oval {
			width: 30%;
		}

		.text-bottom-two {
			bottom: -64px;
			color: map-get($colors, white);
			@include font-size(27);
			left: 27px;
			line-height: 1.2;
			position: absolute;
		}

		.text-sup {
			top: 37px !important;
		}
  }
  
@media screen and (max-width: 600px) {
  .background-experience {
    padding: 40px 0;
  }

  .title {
    @include font-size(24);
  }

  .container-oval {
    flex-direction: column;
  }

  .oval {
    margin-bottom: 40px;
  }

  .text-bottom {
    @include font-size(22);
    line-height: 1.4;
  }

  .text-plant {
    width: 200px;
  }

  .paragraph {
    left: 15px;
    top: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/experience.vue